<template>
  <div class="quote-breakdown">

    <ul v-if="orderSummaryView" class="contract-term quote-breakdown-list">
      <li>
        <span class="key">Contract Term</span>
        <span class="value">{{ this.term }} Months</span>
      </li>
      <li>
        <span class="key">Annual Mileage</span>
        <span class="value">{{ quote.definition.plan.annualDistance }} Miles</span>
      </li>
    </ul>


      <ul class="quote-breakdown-list">
        <li class="comparison-heading">
          <span class="key">Vehicle costs</span>
        </li>

        <li>
                    <span class="key">
                        Vehicle Payment
                        <VDropdown>
                            <button class="tooltip-button"><i class="icon-info-solid"/></button>
                            <template #popper>
                                <p>This payment includes both the finance and maintenance rental of the vehicle and
                                    it will be reflected in the Credit Sale Agreement.</p>
                            </template>
                        </VDropdown>
                    </span>
          <span class="value">{{ getInCurrency(vehicleCosts.vehiclePayment) }}</span>
        </li>

        <li>
                    <span class="key">
                        Insurance Products
                        <VDropdown>
                            <button class="tooltip-button"><i class="icon-info-solid"/></button>
                            <template #popper>
                                <p>This payment includes motor insurance (inc. an accident management provision), a scheme
                                    provision and early termination insurance.</p>
                            </template>
                        </VDropdown>
                    </span>
          <span class="value">{{ getInCurrency(vehicleCosts.insuranceProduct) }}</span>
        </li>


        <li class="comparison-total">
                    <span class="key">
                        Total Motoring Expenses
                        <VDropdown>
                            <button class="tooltip-button"><i class="icon-info-solid"/></button>
                            <template #popper>
                                <p>The sum of the Vehicle Payment and the Insurance Products.</p>
                            </template>
                        </VDropdown>
                    </span>
          <span class="value">{{ getInCurrency(vehicleCosts.totalMotoringExpenses) }}</span>
        </li>

        <li>
                    <span class="key">
                        Approved Mileage Allowance
                        <VDropdown>
                            <button class="tooltip-button"><i class="icon-info-solid"/></button>
                            <template #popper>
                                <p>This is the total Approved Mileage Allowance Payment less the Business Fuel Reimbursement in
                                    the Fuel Illustration below. </p>
                            </template>
                        </VDropdown>
                    </span>
          <span class="value">{{ getInCurrency(vehicleCosts.approvedMileageAllowance) }}</span>
        </li>

        <li>
                    <span class="key">
                        Cash Allowance (After Tax and NI)
                        <VDropdown>
                            <button class="tooltip-button"><i class="icon-info-solid"/></button>
                            <template #popper>
                                <p>Based on your profile you may not receive a Cash Allowance.</p>
                            </template>
                        </VDropdown>
                    </span>
          <span class="value">{{ getInCurrency(vehicleCosts.cashAllowance) }}</span>
        </li>

        <li class="comparison-total">
                    <span class="key">
                        Total Motoring Amounts
                        <VDropdown>
                            <button class="tooltip-button"><i class="icon-info-solid"/></button>
                            <template #popper>
                                <p>This is the sum of your Approved Mileage Allowance and Cash Allowance.</p>
                            </template>
                        </VDropdown>
                    </span>
          <span class="value">{{ getInCurrency(vehicleCosts.totalMotoringAmounts) }}</span>
        </li>

        <li>
                    <span class="key">
                        Colleague Car Contribution
                        <VDropdown>
                            <button class="tooltip-button"><i class="icon-info-solid"/></button>
                            <template #popper>
                                <p>This is the grade standard colleague car contribution based on a benchmark vehicle for the
                                    grade.</p>
                            </template>
                        </VDropdown>
                    </span>
          <span class="value">{{ getInCurrency(vehicleCosts.standardGradeDriverContribution) }}</span>
        </li>

        <li>
                    <span class="key">
                        Trade up/Trade down
                        <VDropdown>
                            <button class="tooltip-button"><i class="icon-info-solid"/></button>
                            <template #popper>
                                <p>By choosing a vehicle with costs above or below the Benchmark Vehicle this creates a Trade
                                    Up or Trade Down</p>
                            </template>
                        </VDropdown>
                    </span>
          <span class="value">{{ getInCurrency(vehicleCosts.tradeUpTradeDown) }}</span>
        </li>

        <li class="comparison-total comparison-heading">
                    <span class="key">
                        Illustrative Vehicle Monthly Net Cost:
                        <VDropdown>
                            <button class="tooltip-button"><i class="icon-info-solid"/></button>
                            <template #popper>
                                <p>This is the sum of your Colleague Car Contribution and the Trade Up/Trade Down and is the net
                                    monthly cost of the vehicle (exc. Fuel) to you.</p>
                            </template>
                        </VDropdown>
                    </span>
          <span class="value">{{ getInCurrency(vehicleCosts.netMonthlyCost) }}</span>
        </li>

        <li v-if="showTraditionalCost" class="comparison-alternate">
                    <span class="key">
                        Cost as a traditional company car:
                        <VDropdown>
                            <button class="tooltip-button"><i class="icon-info-solid"/></button>
                            <template #popper>
                                <p>The Benefit in Kind Amount if this vehicle was provided as a Traditional Company Car.</p>
                            </template>
                        </VDropdown>
                    </span>
          <span class="value">{{ getInCurrency(vehicleCosts.costAsTraditionalCompanyCar) }}</span>
        </li>

        <li class="comparison-divider"></li>

        <li v-if="showFuel" class="comparison-heading">
          <span class="key">Fuel Illustration</span>
        </li>

        <li v-if="showFuel">
                    <span class="key">
                        Business Fuel Cost
                        <VDropdown>
                            <button class="tooltip-button"><i class="icon-info-solid"/></button>
                            <template #popper>
                                <p>This is the monthly cost of the fuel for your provided Business Mileage based on the MPG in the MPG Slider/Tool.</p>
                            </template>
                        </VDropdown>
                    </span>
          <span class="value">{{ getInCurrency(vehicleCosts.businessFuelCost) }}</span>
        </li>

        <li v-if="showFuel">
                    <span class="key">
                        Private Fuel Cost
                        <VDropdown>
                            <button class="tooltip-button"><i class="icon-info-solid"/></button>
                            <template #popper>
                                <p>This is the monthly cost of the fuel for your provided Private Mileage based on the MPG in the MPG Slider/Tool.</p>
                            </template>
                        </VDropdown>
                    </span>
          <span class="value">{{ getInCurrency(vehicleCosts.privateFuelCost) }}</span>
        </li>

        <li v-if="showFuel">
                    <span class="key">
                        Business Fuel Reimbursement
                        <VDropdown>
                            <button class="tooltip-button"><i class="icon-info-solid"/></button>
                            <template #popper>
                                <p>This is a proportion of the total Allowed Mileage Allowance allocated to the business fuel reimbursement for the purpose of the Fuel Illustration.</p>
                            </template>
                        </VDropdown>
                    </span>
          <span class="value">{{ getInCurrency(vehicleCosts.businessFuelReimbursement) }}</span>
        </li>

        <li class="comparison-heading">
                    <span class="key">
                        Net Fuel Cost
                        <VDropdown>
                            <button class="tooltip-button"><i class="icon-info-solid"/></button>
                            <template #popper>
                                <p>The Sum of the Business Fuel Cost, Private Fuel Cost and Business Fuel Reimbursement.</p>
                            </template>
                        </VDropdown>
                    </span>
          <span class="value">{{ getInCurrency(vehicleCosts.netFuelCost) }}</span>
        </li>

        <li>
                    <span class="key">
                        Final Payment/Buyback Amount
                        <VDropdown>
                            <button class="tooltip-button"><i class="icon-info-solid"/></button>
                            <template #popper>
                                <p>This is the final payment for the CSA and the amount you sell the vehicle to the funder if you exercise the Buyback.</p>
                            </template>
                        </VDropdown>
                    </span>
          <span class="value">{{ getInCurrency(vehicleCosts.optionalFinalBalloonPayment) }}</span>
        </li>

        <li class="comparison-divider"></li>

        <li class="comparison-title mt-4">
                    <span class="key">
                        Overall Net Monthly Cost:
                        <VDropdown>
                            <button class="tooltip-button"><i class="icon-info-solid"/></button>
                            <template #popper>
                                <p>This is the sum of your Illustrative Vehicle Monthly Net Cost and the Fuel Illustration detailed below.</p>
                            </template>
                        </VDropdown>
                    </span>
          <span class="value">{{ getInCurrency(vehicleCosts.totalNetCost) }}</span>
        </li>

      </ul>

  </div>

</template>

<script type="text/javascript">

export default {
  name: "ecoamaps-quote-breakdown",
  props: [
    'quote',
    'quoteCosts',
    'driverProfile',
    'type',
    'showFuel',
    'showTraditionalCost',
    'orderSummaryView',
    'averagePencePerMile',
    'totalEstimatedElectricCostPerMonth'
  ],
  computed: {

    q() {
      if (this.quote.quote !== undefined) {
        return this.quote.quote;
      }
      return this.quote;
    },

    term() {
      if (this.q.term !== undefined) {
        return this.q.term;
      }
      return this.q.definition.plan.term;
    },

    taxCalculations() {
      if (this.q.taxCalculations?.calculationResults) {
        return this.q.taxCalculations.calculationResults[0];
      }
      return this.q.taxCalculations;
    },

    vehicleCosts() {
      if (!this.driverProfile || !this.quote) {
        return {}
      }

      let vehicleCosts = {
        vehiclePayment: Number(this.q.details.pricing.totalIncVAT),
        insuranceProduct: Number(this.getMonthlyCost(this?.taxCalculations?.employeeCostPrivateCar?.motoringAndFinance_InsuranceCost)),
        cashAllowance: Number(this.cashAllowanceNet),
        standardGradeDriverContribution: Number(this.driverProfile.contacts[0].telephoneNumber2),
        costAsTraditionalCompanyCar: Number(this.traditionalCarCost),
        businessFuelCost: Number(this.getMonthlyCost(this?.taxCalculations?.employeeCostPrivateCar?.businessMileage_BusinessFuelCost)),
        privateFuelCost: Number(this.getMonthlyCost(this?.taxCalculations?.employeeCostPrivateCar?.privateMileage_PrivateFuelCost)),
        businessFuelReimbursement: Number(this.getMonthlyCost(this?.taxCalculations?.employeeCostPrivateCar?.businessMileage_BusinessMileageAllowance)),
        optionalFinalBalloonPayment: Number(this.q.details.pricing.balloonPaymentExVAT)
      }
      vehicleCosts.approvedMileageAllowance = Number(this.driverProfile.contacts[0].telephoneNumber1) - Math.abs(vehicleCosts.businessFuelReimbursement)
      vehicleCosts.totalMotoringExpenses = vehicleCosts.vehiclePayment + vehicleCosts.insuranceProduct
      vehicleCosts.totalMotoringAmounts = vehicleCosts.approvedMileageAllowance + vehicleCosts.cashAllowance
      vehicleCosts.netMonthlyCost = vehicleCosts.totalMotoringExpenses - Math.abs(vehicleCosts.totalMotoringAmounts)
      vehicleCosts.netFuelCost = vehicleCosts.businessFuelCost + vehicleCosts.privateFuelCost + vehicleCosts.businessFuelReimbursement
      vehicleCosts.totalNetCost = vehicleCosts.netMonthlyCost + vehicleCosts.netFuelCost


      vehicleCosts.tradeUpTradeDown = vehicleCosts.netMonthlyCost - Math.abs(vehicleCosts.standardGradeDriverContribution)

      return vehicleCosts
    },

    totalNetCost() {
      switch (this.type.toUpperCase()) {
        case 'BCH':
          return this?.taxCalculations?.employeeCostCompanyCar?.totals_NetPresentValueNPV;
        case 'PCH':
          return this?.taxCalculations?.employeeCostPrivateCar?.totals_NetPresentValueNPV;
      }
    },

    vehiclePayment() {
      const rentalsPayment = Number(this?.taxCalculations?.employeeCostPrivateCar?.motoringAndFinance_RentalsPayments);
      const maintenanceCost = Number(this?.taxCalculations?.employeeCostPrivateCar?.motoringAndFinance_MaintenanceCost);
      const residualValue = Number(this?.taxCalculations?.employeeCostPrivateCar?.motoringAndFinance_ResidualValue);
      return rentalsPayment + maintenanceCost + residualValue;
    },

    cashAllowanceNet() {
      const cashAllowance = this.getMonthlyCost(Math.abs(this?.taxCalculations?.employeeCostPrivateCar?.cashAllowanceReconciliation_CashAllowance));
      const cashIncomeTax = this.getMonthlyCost(Number(this?.taxCalculations?.employeeCostPrivateCar?.cashAllowanceReconciliation_IncomeTaxOnCashAlternative));
      const cash1NIC = this.getMonthlyCost(Number(this?.taxCalculations?.employeeCostPrivateCar?.cashAllowanceReconciliation_Class1NICOnCashAllowance));
      return cashAllowance - (cashIncomeTax + cash1NIC);
    },

    traditionalCarCost() {
      if (this.driverProfile.incomeTaxBand.ratePercent == this.q.details.biK1Rate) {
        return this.q.details.biK1;
      }

      if (this.driverProfile.incomeTaxBand.ratePercent == this.q.details.biK2Rate) {
        return this.q.details.biK2;
      }

      if (this.driverProfile.incomeTaxBand.ratePercent == this.q.details.biK3Rate) {
        return this.q.details.biK3;
      }

      if (this.driverProfile.incomeTaxBand.ratePercent == this.q.details.biK4Rate) {
        return this.q.details.biK4;
      }
    },

    estimatedFuelCost() {
      return this.totalEstimatedElectricCostPerMonth;
    }

  },
  methods: {

    getMonthlyCost(value) {
      return (Number(value) / this.term);
    },

    getInCurrency(value, currency = "£") {
      return currency + Number(value).toFixed(2);
    }

  }
}

</script>
